import { z } from 'zod';

// Auth schemas
export const loginSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
});

export const registerSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Please enter a valid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  phone: z.string().optional(),
});

// Profile schemas
export const emergencyContactSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  relation: z.string().min(2, 'Relation must be at least 2 characters'),
  phone: z.string().min(10, 'Please enter a valid phone number'),
  email: z.string().email('Please enter a valid email address').optional().or(z.literal('')),
  isPrimary: z.boolean().default(false),
});

export const healthProfileSchema = z.object({
  fullName: z.string().min(2, 'Full name must be at least 2 characters'),
  dateOfBirth: z.string().min(1, 'Date of birth is required'),
  gender: z.enum(['Male', 'Female', 'Other'], {
    errorMap: () => ({ message: 'Please select a gender' }),
  }),
  bloodGroup: z.enum(['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'], {
    errorMap: () => ({ message: 'Please select a blood group' }),
  }),
  allergies: z.array(z.string()).optional(),
  chronicConditions: z.array(z.string()).optional(),
  currentMedications: z.array(z.object({
    name: z.string().min(1, 'Medication name is required'),
    dosage: z.string().min(1, 'Dosage is required'),
    frequency: z.string().min(1, 'Frequency is required'),
  })).optional(),
  pastSurgeries: z.array(z.string()).optional(),
  emergencyContacts: z.array(emergencyContactSchema).min(2, 'At least 2 emergency contacts are required').max(5, 'Maximum 5 emergency contacts allowed'),
  medicalNotes: z.string().optional(),
  organDonor: z.boolean().default(false),
  consentTimeout: z.number().min(30).max(300).default(60),
  isPublic: z.boolean().default(true),
});

// QR Scan schema
export const qrScanSchema = z.object({
  qrToken: z.string().min(1, 'QR token is required'),
  location: z.object({
    lat: z.number(),
    lng: z.number(),
  }).optional(),
});

// Consent response schema
export const consentResponseSchema = z.object({
  scanId: z.string().min(1, 'Scan ID is required'),
  approved: z.boolean(),
});

// Hospital search schema
export const hospitalSearchSchema = z.object({
  query: z.string().min(2, 'Search query must be at least 2 characters'),
});

export const nearbyHospitalsSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  radius: z.number().min(100).max(50000).default(5000),
});

// Chatbot schema
export const chatbotSchema = z.object({
  message: z.string().min(1, 'Message is required'),
  profileId: z.string().optional(),
  conversationHistory: z.array(z.object({
    role: z.enum(['user', 'assistant']),
    content: z.string(),
  })).optional(),
});

export default {
  loginSchema,
  registerSchema,
  healthProfileSchema,
  emergencyContactSchema,
  qrScanSchema,
  consentResponseSchema,
  hospitalSearchSchema,
  nearbyHospitalsSchema,
  chatbotSchema,
};
